<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-col class="pa-0">
    <v-flex my-2>
      <SimpleCard>
        <v-row
          xs12
          md12
          xl12
          lg12
        >
          <v-flex>
            <v-layout>
              <v-flex
                xl3
                md3
                lg3
              >
                <v-card-actions
                  v-if="driverStats"
                  px-0
                  py-0
                >
                  <v-list-item class="py-0 my-0 px-0 min-height-list-item">
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Total Drivers
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ driverStats.total }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    class="py-0 my-0 px-0 min-height-list-item"
                    @click="filterDrivers('active')"
                  >
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Active
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ driverStats.active }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    class="py-0 my-0 px-0 min-height-list-item"
                    @click="filterLockedOut"
                  >
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Locked Out
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ driverStats.lockedOut }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    class="py-0 my-0 px-0 min-height-list-item"
                    @click="gotoDriverApplications"
                  >
                    <v-list-item-content class="py-0 my-0">
                      <v-list-item-title class="cmr-label-text">
                        Applying
                      </v-list-item-title>
                      <v-list-item-subtitle class="cmr-value-text">
                        {{ driverStats.applying }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-actions>
              </v-flex>
              <v-flex
                xl6
                md6
                lg6
              >
                <DriverSearchBox
                  class="mb-2"
                  :query="query"
                  @search="search"
                  @clear="clear"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-row>
      </SimpleCard>
    </v-flex>
    <v-flex>
      <v-row>
        <v-flex md12 lg12 xl12 sm12 xs12>
          <v-progress-linear
            class="mt-2"
            v-if="loading"
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex
          md12
          lg12
          xl12
          sm12
          xs12
        >
          <v-data-table
            disable-pagination
            dense
            :hide-default-footer="true"
            :headers="headers"
            :items="drivers"
            item-key="id"
            class="elevation-0"
            style="font-size: 11px !important;"
            :item-class="row_classes"
          >
            <template v-slot:item.id="{ item }">
              <div
                class="d-flex align-center"
                style="cursor: pointer"
                @click="gotoDriver(item)"
              >
                <v-avatar
                  v-if="item.picture"
                  size="24"
                  class="me-2"
                >
                  <v-img :src="item.picture" />
                </v-avatar>
                <v-avatar
                  v-else
                  size="24"
                  class="me-2 bg-gradient-default"
                >
                  <span class="text-white text-xs">{{ item.id }}</span>
                </v-avatar>
                <v-btn
                  small
                  link
                  text
                >
                  {{ item.id }}
                </v-btn>
              </div>
            </template>
            <template v-slot:item.current_rating="{ item }">
              <div class="d-flex align-center">
                {{ item.current_rating ? item.current_rating.toFixed(2) : 0 }}
              </div>
            </template>
            <template v-slot:item.contact_number="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ attrs, on }">
                  <a
                    href="javascript:void(0)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.contact_number }}
                  </a>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="item.contact_number"
                  >
                    <v-list-item-title>
                      <a :href="'tel:' + item.contact_number">Call</a>
                    </v-list-item-title>
                    <v-spacer />
                    <v-icon
                      small
                      color="blue"
                      class="ml-2"
                      @click="copyContent(item.contact_number)"
                    >
                      mdi-content-copy
                    </v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.details.homeNumber="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ attrs, on }">
                  <a
                    href="javascript:void(0)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.details.homeNumber }}
                  </a>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="item.details.homeNumber"
                  >
                    <v-list-item-title>
                      <a
                        :href="'tel:' + item.details.homeNumber"
                      >Call</a>
                    </v-list-item-title>
                    <v-spacer />
                    <v-icon
                      small
                      color="blue"
                      class="ml-2"
                      @click="copyContent(item.details.homeNumber)"
                    >
                      mdi-content-copy
                    </v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.email="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ attrs, on }">
                  <a
                    :title="item.email"
                    href="javascript:void(0)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.email.substr(0,10) }}
                  </a>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="item.email"
                  >
                    <v-list-item-title>
                      <a
                        :href="'mailto:' + item.email"
                      >Email Rider</a>
                    </v-list-item-title>
                    <v-spacer />
                    <v-icon
                      small
                      color="blue"
                      class="ml-2"
                      @click="copyContent(item.email)"
                    >
                      mdi-content-copy
                    </v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.licence_number="{ item }">
              <div class="d-flex align-center">
                {{ item.licence_number ? item.licence_number.substr(0, 5) : '' }}
              </div>
            </template>
            <template v-slot:item.licence_type="{ item }">
              <div class="d-flex align-center">
                {{ findLicenseType(item) }}
              </div>
            </template>
            <template v-slot:item.licence_renewal_date="{ item }">
              <div class="d-flex align-center">
                {{ formatDate(item.licence_renewal_date) }}
              </div>
            </template>
            <template v-slot:item.last_job_time="{ item }">
              <div class="d-flex align-center">
                {{ getTimePassedSince(item.last_job_time) }}
              </div>
            </template>
            <template v-slot:item.last_week_hours_worked="{ item }">
              <div class="d-flex align-center" v-if="item.last_week_hours_worked > 0">
                {{ item.last_week_hours_worked }}
              </div>
            </template>
            <template v-slot:item.taxi.council="{ item }">
              <v-chip :title="item.taxi.council" :color="getCouncilBackgroundColor(item)" x-small :class="{'white--text' : getCouncilBackgroundColor(item)}">
                {{ item.taxi.council ? item.taxi.council.substr(0,7) : '' }}
              </v-chip>
            </template>
            <template v-slot:item.working_status="{ item }">
              <div
                v-if="item.likely_working"
              >
                <v-chip
                  color="blue lighten-4"
                  x-small
                >
                  {{ "LIKELY WORKING" }}
                </v-chip>
              </div>
              <div
                v-if="item.online"
              >
                <v-chip
                  color="green lighten-4"
                  x-small
                >
                  {{ "ON" }}
                </v-chip>
              </div>

              <div
                v-if="!item.online"
              >
                <v-chip
                  color="red lighten-4"
                  x-small
                >
                  {{ "OFF" }}
                </v-chip>
              </div>
            </template>
            <template v-slot:item.options="{ item }">
              <div class="align-center">
                <v-menu
                  offset-y
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      x-small
                      text
                      link
                      light
                      color="blue"
                      class="ml-1 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Options
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="showResetPasswordDialog(item)"
                    >
                      <v-list-item-title v-text="'Reset Password'" />
                    </v-list-item>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="showResetDriverDialog(item)"
                    >
                      <v-list-item-title v-text="'Recover Driver'" />
                    </v-list-item>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="goto('/drivers/edit/' + item.id)"
                    >
                      <v-list-item-title v-text="'Update'" />
                    </v-list-item>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="goto('/drivers/edit/' + item.id)"
                    >
                      <v-list-item-title v-text="'Update Working Hours'" />
                    </v-list-item>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="goto(`/invoices/driver/${item.id}`, true)"
                    >
                      <v-list-item-title v-text="'Invoices'" />
                    </v-list-item>
                    <v-list-item
                      class="py-0 my-0 list-item-height"
                      dense
                      link
                      @click="goto(`/driver/vehicle_photos/${item.id}`, true)"
                    >
                      <v-list-item-title v-text="'Driver Pics'" />
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-data-table>
          <v-card elevation="0">
            <v-divider />
            <v-flex
              v-if="!loading"
              class="mt-1"
            >
              <v-pagination
                v-model="pagination.page"
                :length="num_pages"
                @input="changePage"
              />
              <!--
              <v-row justify="center">
                <v-btn
                  elevation="0"
                  class="mr-1"
                  small
                  :disabled="pagination.page <= 1"
                  @click="changePage(pagination.page - 1)"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>

                <v-btn
                  elevation="0"
                  small
                  :disabled="noMoreResults == true"
                  @click="changePage(pagination.page + 1)"
                >
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-row>
-->
            </v-flex>
          </v-card>
        </v-flex>
      </v-row>
      <v-row>
        <ResetPassword
          :show="showResetPassword"
          :user-i-d="userId"
          :user-name="username"
          @hideResetPassword="showResetPassword = false"
        />
      </v-row>
      <v-row>
        <v-dialog
          v-model="resetDriverDialog"
          persistent
          max-width="290"
        >
          <v-card>
            <v-card-title class="text-h5">
              Recover Driver
            </v-card-title>
            <v-card-text>
              This action will make driver available.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="resetDriverDialog = false"
              >
                Disagree
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="resetDriver"
              >
                Agree
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>      </v-row>
    </v-flex>
  </v-col>
</template>

<script>
import Stat from "@/components/widget/Stat.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverList from "@/components/driver/DriverList.vue";
import DriverSearchBox from "@/components/driver/DriverSearchBoxV2.vue";
import Driver from "@/views/driver/Driver.vue";

import qs from "qs";
import axios from "axios";
import moment from 'moment'
import ResetPassword from "@/components/customer/ResetPassword.vue";
axios.defaults.withCredentials = true;

export default {
  name: "DriversTable",
  components: {
    ResetPassword,
    SimpleCard,
    DriverList,
    DriverSearchBox,
    Driver,
    Stat,

  },

  data: function () {
    return {
      pagination: { page: 1 },
      showResetPassword: false,
      resetDriverDialog: false,
      driverId: '',
      userId: '',
      username: '',
      drivers: [],
      headers: [
        {
          text: 'ID',
          sortable: true,
          value: 'id',
        },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Contact', value: 'contact_number' ,sortable: false},
        { text: 'Contact 2', value: 'details.homeNumber' ,sortable: false},
        { text: 'Council', value: 'taxi.council' ,sortable: true},
        { text: 'Ride', value: 'taxi.type' ,sortable: false},
        { text: 'PAX', value: 'taxi.num_seats' ,sortable: true, width: '5%'},
        { text: 'Reg', value: 'taxi.registration_number' ,sortable: false},
        { text: 'Plate', value: 'taxi.plate_number' ,sortable: false},
        { text: 'Make', value: 'taxi.make' ,sortable: false},
        { text: 'Model', value: 'taxi.model' ,sortable: false},
        { text: 'Color', value: 'taxi.colour' ,sortable: false},
        { text: 'Rating', value: 'current_rating' ,sortable: true, width: '5%'},
        { text: 'License', value: 'licence_number' ,sortable: false},
        { text: 'Lic. Type', value: 'licence_type' ,sortable: false},
        { text: 'Ren. Date', value: 'licence_renewal_date' ,sortable: false, width: '1%'},
        { text: 'Compliance', value: 'taxi.compliance_certificate_expiry' ,sortable: false},
        { text: 'Working Status', value: 'working_status' ,sortable: false},
        { text: 'Hours Worked', value: 'last_week_hours_worked', sortable: true },
        { text: 'Last job', value: 'last_job_time', sortable: true},
        { text: '', value: 'invoice_details' ,sortable: false},
        { text: '', value: 'options' ,sortable: false, width: '2%'},
      ],
      driver: null,
      bookings: [],
      offset: 0,
      count: 100,
      query: {
        search: "",
        rideType: '',
        lockedOut: false,
        filter: "",
        rating: "",
        plannerFilter: ""
      },
      loading: true,
      loadingDriver: false,
      num_pages: 0,
      noMoreResults: false,
      driverStats: null,
      councilColorCodes: {
        southampton: "green",
        "southampton city council": "green",
        portsmouth: "blue",
        "portsmouth ua": "blue",
        bcp: "red",
        eastleigh: "yellow",
        "new forest": "orange",
        "new forest district council": "orange",
        "eastleight borough council": "yellow",
        "winchester council": "purple",
        "lewes": "gold",
        "hart": "mustard",
        "north dorset": "indigo",
        "west dorset": "blue lighten-3",
        "londond": "coral",
        "mendip": "aqua",
        "dover": "brown lighten-2",
        "havant": "crimson",
        "walsall": "chocolate",
        "adur": "brown",
        "caradon": "cyan",
        "pembrokeshire": "teal",
        "fareham": "lime",
        "east hampshire": "amber",
        "london heathrow": "deep-orange",
      }
    };
  },
  watch: {
    "query.rating" () {
      this.query.plannerFilter = ""
    },
  },
  mounted: async function () {
    this.getDrivers();
    this.getSummary();
  },
  methods: {
    resetDriver: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/driver/${this.driverId}/reset`;
      
        let response = await axios.get(url, {
          params: {},
        });
        
        this.resetDriverDialog = false
      
      } catch (error) {
        this.resetDriverDialog = false;
        alert('Failed to rest driver')
      }
    },
    getTimePassedSince(datetime) {
      if (datetime) {
        return moment(datetime).fromNow(true)
      }
      return 'NA'
    },
    getCouncilBackgroundColor (item) {
      if (item.taxi && item.taxi.council) {
        if (this.councilColorCodes[item.taxi.council.toLowerCase()]) {
          return this.councilColorCodes[item.taxi.council.toLowerCase()]
        }
      }
      return ''
    },
    copyContent (content) {
      console.log(content)
      if (content) {
        navigator.clipboard.writeText(content);
      }
    },
    showResetPasswordDialog (driver) {
      this.userId = driver.user_id,
      this.username = driver.name,
      this.showResetPassword = true
    },
    showResetDriverDialog (driver) {
      this.driverId = driver.id
      this.resetDriverDialog = true
    },
    goto (route, isNewTab = false) {
      if (isNewTab) {
        return window.open(route)
      }
      return this.$router.push(route)
    },
    filterDrivers(filter) {
      this.query = {}
      
      if (filter == 'active') {
        this.query.lockedOut = false
      }
      this.getDrivers()
    },
    filterLockedOut() {
      this.query = {}
      this.query.lockedOut = true
      this.getDrivers()
    },
    row_classes(item) {
      if (item.taxi.num_seats >= 6) {
        return "orange increased-heigth";
      }
      return 'increased-height'
    },
    findDriverWorkingStatus(driver) {
      if (driver.likelyWorking) {
        return 'likely working'
      }
      if (driver.online) {
        return 'online'
      }
      if (!driver.online) {
        return 'offline'
      }
    },
    formatDate (date) {
      if (date) {
      return moment(date).format("MM-DD-YYYY")
      }
      return null
    },
    findLicenseType(driver){
      if (driver.hire_number && !driver.hackney_number) {
        return 'PH' + driver.hire_number
      }
      if (!driver.hire_number && driver.hackney_number) {
        return 'HC' + driver.hackney_number
      }
    },
    gotoDriver (row) {
      return window.open('/drivers/' + row.id, '_blank')
    },
    gotoDriverApplications () {
      return window.open('/drivers/applications')
    },
    search: function () {
      this.pagination.page = 1;
      this.noMoreResults = false;
      this.query.lockedOut = false;
      this.getDrivers();
    },

    clear: function () {
      this.query = {
        search: "",
        lockedOut: false,
      };
    },
    changePage: function (page) {
      this.pagination.page = page;
      this.getDrivers();
    },
    getDrivers: async function () {
      this.loading = true;

      try {
        let queryRideType =
          this.query.rideType == "" ? -1 : this.query.rideType;

        var url = `${this.$store.state.apiUrl}/driver/all?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}`;

/*
        if (this.query.rideType > 0) {
          for (var i = 0; i < this.query.rideType.length; i++) {
            url += `&rideType=${this.query.rideType[i]}`;
          }
        }
*/
        if (this.query.rideType) {
          url += `&rideType=${this.query.rideType}`;
        }

        if (this.query.lockedOut) {
          url += `&lockedOut=${this.query.lockedOut}`;
        }

        if (this.query.search) {
          url += `&query=${this.query.search}`;
        }

        if (this.query.rating) {
          url += `&rating=${this.query.rating}`;
        }

        if (this.query.status) {
          url += `&status=${this.query.status}`;
        }

        if (this.query.plannerFilter) {
          url += `&plannerFilter=${this.query.plannerFilter}`;
        }

        let response = await axios.get(url, {
          params: {},
        });
        this.loading = false

        console.log(response.data);

        if (response.data.error != null) {
          if (response.data.error == "no_results") {
            this.noMoreResults = true;
          } else {
            this.noMoreResults = false;
          }
        }

        var drivers = response.data.drivers;
        if (drivers != null && drivers.length < this.count) {
          this.noMoreResults = true;
        } else if (drivers != null && drivers.length == this.count) {
          this.noMoreResults = false;
        }

        this.drivers = drivers;
        console.log('response is: ', response)

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get drivers " + error);
      }
    },
    getDriver: async function (id) {
      this.loadingDriver = true;
      this.driver = null;

      try {
        var url = `${this.$store.state.apiUrl}/driver/${id}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driver = response.data;

        this.loadingDriver = false;
      } catch (error) {
        this.loadingDriver = false;
        console.log("Failed to get driver " + error);
      }
    },
    getSummary: async function (id) {
      try {
        var url = `${this.$store.state.apiUrl}/driver/summary`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverStats = response.data;
      } catch (error) {
        console.log("Failed to get stats " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style  lang="scss" >
.driverNavigation {
  padding-left: 12px;
  padding-right: 12px;
  color: #999fb8 !important;
}


.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11px !important;
}

.min-height-list-item {
  min-height: 0px !important;
}

.orange {
  background-color: #e7b361;
}

.increased-height {
  height: 40px;
}



</style>
